import { useContext } from "react";
import TastaturContext from "./TastaturContext";

const useTastaturContext = () => {
  const context = useContext(TastaturContext);
  return context;
};
export default useTastaturContext;
